import React from 'react';

import { TpDashboardElement, TpDashboardContext, TpDashboardVerticalLayoutDefinition } from '../dashboard/interfaces';
import { TpDataContext } from '../../../data/interfaces';
import { renderDashboardElement } from '../dashboard/render-elem';
import { dashboardWidgetPadding } from '../dashboard/layout-hints';
import { useAppDispatch } from '../../../app/hooks';
import { ElementEditTools } from '../dashboard/edit-mode/ElementEditTools';

interface TpDashboardVerticalLayoutProps {
  parentElemDef: TpDashboardElement | null;
  dataContext: TpDataContext;
  dashboardContext: TpDashboardContext;
  elemDef: TpDashboardVerticalLayoutDefinition;
}

function DashboardVerticalLayout({
  dataContext,
  parentElemDef,
  elemDef,
  dashboardContext,
}: TpDashboardVerticalLayoutProps) {
  const dispatch = useAppDispatch();

  const getChildRelSize = (child: TpDashboardElement) => {
    return ('elemLayoutHints' in child ? child.elemLayoutHints?.sizeYRelative : undefined) || 1;
  };

  let totalRelSize = 0;
  for (const child of elemDef.elements) {
    totalRelSize += getChildRelSize(child);
  }
  totalRelSize = Math.max(1, totalRelSize);
  const totalPadding = (elemDef.elements.length - 1) * dashboardWidgetPadding;

  const spacer = <div style={{ backgroundColor: 'transparent', height: `${dashboardWidgetPadding}px` }} />;

  const width = dashboardContext.editMode ? 'calc(100% - 60px)' : '100%';

  const style: any = { width: '100%', position: 'relative' };
  // Note: elementVerticalSizeOffset is intentionally not applied here.
  // This layout behaves differently from Widget.tsx; see issue #988 for details.
  const height = elemDef.elemLayoutHints?.sizeYAbsolute;
  if (height) style.height = `${height}px`;
  if (dashboardContext.editMode) {
    style.border = '1px dashed rgb(255,128,0)';
    style.boxSizing = 'border-box';
  }
  return (
    <div style={style}>
      <div style={{ width, height: '100%' }}>
        {elemDef.elements.map((el, idx) => (
          <React.Fragment key={`idx_${idx}`}>
            <div
              style={{
                height: `calc(${(getChildRelSize(el) / totalRelSize) * 100}% - ${
                  totalPadding / elemDef.elements.length
                }px)`,
                width: '100%',
                display: 'inline-block',
                whiteSpace: 'normal',
                verticalAlign: 'top',
              }}
            >
              {renderDashboardElement(elemDef, el, dataContext, dashboardContext)}
            </div>
            {idx < elemDef.elements.length - 1 && spacer}
          </React.Fragment>
        ))}
        {dashboardContext.editMode && (
          <ElementEditTools
            dataContext={dataContext}
            dashboardContext={dashboardContext}
            parentElemDef={parentElemDef}
            elemDef={elemDef}
            dispatch={dispatch}
          />
        )}
      </div>
    </div>
  );
}

export default DashboardVerticalLayout;
